import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initDatadog } from "@/lib/datadog";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes
      gcTime: 10 * 60 * 1000,   // 10 minutes
      retry: 1,
    },
  },
});

async function bootstrap() {
  if (import.meta.env.VITE_ENABLE_MOCK_API === "true") {
    const { enableMockApi } = await import("@/mocks");
    await enableMockApi();
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );

  // Defer Datadog init until after first render so it does not compete with
  // the initial paint. The SDK queues any events fired before init completes.
  setTimeout(() => initDatadog(), 0);
}

void bootstrap();

/* 
// Production mode with Clerk authentication
// Uncomment this block and set VITE_CLERK_PUBLISHABLE_KEY to enable

import { ClerkProvider } from '@clerk/clerk-react'

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </StrictMode>,
)
*/
